import React, { useEffect } from 'react';
import $ from "jquery";
import throttle from "lodash.throttle";
import { Loader } from '../../loader/index';

const DemandPlannerWeekly = (props) => {

    useEffect(()=>{
      if(props.getDataFromChild){
        props.fetchDemandPlannerWeekly();
      }
    },
    //eslint-disable-next-line
    []
    )

    const load_more = throttle(props.load_Skus, 800, {
        trailing: false,
      });

    const handleScroll = (e) => {
        var ignoreScrollEvents = false;
        function syncScroll(element1, element2) {
          element1.scroll(function (e) {
            var ignore = ignoreScrollEvents;
            ignoreScrollEvents = false;
            if (ignore) return;
    
            ignoreScrollEvents = true;
            element2.scrollTop(element1.scrollTop());
          });
        }
        syncScroll($("#div2"), $("#div1"));
    
        if (props.isDemandPlannerLoading) return;
        let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
        if (bottom) {
          load_more()
        }
      }

    if(props.isLoadingInitial){
      return(
        <Loader flag={true} />
      )
    }
    else{
      return ( 
          <div className='two-tables'>
  
          <div id="div1" className='table-one-container'>
  
            <table className='table-one'>
              <thead>
  
                <tr className='month-header-row align-text-left'>
                  <th colSpan="2" className='month-heading right-border-cell'>Month</th>
                </tr>
  
                <tr className='year-header-row align-text-left'>
                  <th colSpan="2" className='year-heading right-border-cell'>Year</th>
                </tr>
  
                <tr className='description-dd-header-row align-text-left'>
                  <th className='description-heading right-border-cell sticky-header'>Description</th>
                  <th className='dd-heading right-border-cell sticky-header'>Demand Drivers</th>
                </tr>
  
              </thead>
  
              <tbody>
  
                {props.state.data && props.state.data.map((item) => (
                  Object.entries(item.DemandDrivers).map((elm, ind) => (
  
                    <tr key={ind} className={`table-one-data-row align-text-left 
                    ${Object.entries(item.DemandDrivers).length - 1 === ind ? 'row-bg' : ''}
                    ${elm[0] === 'TotalEvents' || elm[0] === 'TotalNumber' || elm[0] === 'ConstraintDemand' || elm[0] === 'UnconstrainedDemand' ? 'row-font-color' : ''}`}>
                      <td className='table-one-data-row-description-dd' style={{ fontWeight: '600' }}>{item.Description}</td>
                      <td className='table-one-data-row-description-dd'>{elm[0]}</td>
                    </tr>
  
                  ))
                ))}
  
              </tbody>
            </table>
  
          </div>
  
          <div id="div2" className='table-two-container' 
          onScroll={(e) => handleScroll(e)}
          >
  
            <table className='table-two'>
              <thead>
                <tr className='month-header-row'>
                  {props.DATA.QUARTER_MONTHS.map((month, ind) => (
                    <th key={ind} colSpan={month.name === 'JAN' || month.name === 'APR' || month.name === 'JUL' || month.name === 'OCT' ? '5' : '4'}
                      className='month-heading-table-two'>{month.name}</th>
                  ))}
                </tr>
  
                <tr className='year-header-row'>
                  {props.DATA.WEEK_NO.map((year, ind) => (  
                    <th key={ind} className='cell-table-two'>{(props.state.selectedYear && props.state.selectedWeekFrom === '52')
                      ? parseInt(props.state.selectedYear) + 1 : props.state.selectedYear}</th>
                  ))}
                </tr>
  
                <tr className='description-dd-header-row'>
                  {props.DATA.WEEK_NO.map((week, ind) => (
                    <th key={ind} className='cell-table-two sticky-header'>{week.label2}</th>
                  ))}
                </tr>
  
              </thead>
  
              <tbody>
  
                {props.state.data && props.state.data.map((item) => (
                  Object.entries(item.DemandDrivers).map((elm, index) => (
                    <tr key={index} className={`table-two-data-row ${Object.entries(item.DemandDrivers).length - 1 === index ? 'row-bg' : ''}`}>
                      {Object.entries(elm[1]).map((val, ind) => (
                        <td key={ind}
                          className={`table-two-data-row-cell ${val[0] === 'wk5' || val[0] === 'wk9' || val[0] === 'wk13'
                            || val[0] === 'wk18' || val[0] === 'wk22' || val[0] === 'wk26'
                            || val[0] === 'wk31' || val[0] === 'wk35' || val[0] === 'wk39'
                            || val[0] === 'wk44' || val[0] === 'wk48' ? 'right-border-cell' : ''}
                            ${elm[0] === 'TotalEvents' || elm[0] === 'TotalNumber' || elm[0] === 'ConstraintDemand' || elm[0] === 'UnconstrainedDemand' ? 'row-font-color' : ''}`}
                        >{val[1]?.toFixed(3)}</td>
                      ))}
                    </tr>
                  ))
                ))}
  
              </tbody>
  
            </table>
  
          </div>
  
        </div>
       );
    }
}
 
export default DemandPlannerWeekly;